import {Fragment, useEffect, useRef, useState, useContext} from "react";
import ErrorLabel from '../../components/error';
let lang = localStorage.getItem("i18nextLng");
const languageDir = "language-" + lang;
export function DropDownInput1({
                                  styles,
                                  title,
                                  placeholder,
                                  disabled = false,
                                  className,
                                  isSecondary,
                                  inputName,
                                  options = [{value: "0", text: (lang == 'en' ? 'Choose value' : 'إختيار قيمة') }],
                                  onSelect,
                                  defaultOption = null,
                                  onfilter,
                                  isepart,
                                  errorLabel ,
                                  force = false
                              }) {
    const optionsRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(defaultOption != null  || defaultOption != undefined ? defaultOption : {value: "0", text: (lang == 'en' ? 'Choose value' : 'إختيار قيمة') });
  
    useEffect(() => {

        /**
         * if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (optionsRef.current && !optionsRef.current.contains(event.target) && isOpen === true) {
                setIsOpen(false);
            }
        }
        // if(placeholder != null || placeholder != undefined){
        //     alert(placeholder);
        //     let resultValue = options.find((e)=>e.value === placeholder);
        //     selectOption(resultValue); 
        //     }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [optionsRef, isOpen]);



    function selectOption(option) {
         if(onSelect)
         {
             const val = option.value !== '0'? option.value : '';
             onSelect(val);
         }
        setIsOpen(false);
        setSelectedOption(option);
          if (onfilter) 
              if(defaultOption!==option.text)
           onfilter(option);
        // if (isepart)
        //onfilter(option);

    }

    return (

        <Fragment>

            {
                inputName ? (
                    <input type="hidden" value={selectOption.value}/>
                ) : null
            }

            <div className={"dropdown " + languageDir + ' ' + className}>


                <div className={"dropdown-label " + (isSecondary && "secondary")}>{title}
                </div>
                <ErrorLabel errorTitle={errorLabel}/>
                <div ref={optionsRef} className={"dropdown-input"}>
                    <div className={"dropdown-field " + (isSecondary && "secondary")} style={styles ? styles : null} onClick={() => {
                        setIsOpen(!isOpen);
                    }}>
                        <div className="dropdown-field-text">
                        {
                        
                        selectedOption.text 
                        
                        }
                        </div>
                        <div className={"dropdown-field-arrow " + (isOpen && "invert")}>
                            <img src="/assets/icons/arrow.svg" alt="arrow"/>
                        </div>

                    </div>
                    {
                    !disabled && <div className={"dropdown-options " + (isOpen || "hidden")}>
                    <ul>
                       {
                           options.map((option) => {
                           
                                   return (
                                       <li key={option.value} onClick={() =>{ 
                                           selectOption(option); 
                                           //  const val = option.value !== '0'? option.value : '';
                                           //  onSelect(val);
                                           }} className={option.value}>
                                           <span>{option.text}</span>
                                       </li>
                                   );
                             
                           }
                           )
                       }

                   </ul>
               </div>
                    }


                </div>

            </div>

        </Fragment>
    );
}
